import { Injectable } from '@angular/core';
import { AngularFirestore, CollectionReference, DocumentReference } from '@angular/fire/compat/firestore';
import { WalletType } from '@app/@shared/models/wallet-type.model';

@Injectable({
  providedIn: 'root',
})
export class WalletTypeService {
  private collection: CollectionReference<WalletType>;

  constructor(private firestore: AngularFirestore) {
    this.collection = this.firestore.collection<WalletType>('walletTypes').ref;
  }

  // Obtener todos los elementos
  async getAll(): Promise<WalletType[]> {
    const snap = await this.collection.get();
    const data = snap.docs.map((o) => {
      return { uid: o.id, ...o.data() };
    });
    return data;
  }

  // Obtener un elemento por ID
  async getById(uid: string): Promise<WalletType | null> {
    const snap = await this.collection.doc(uid).get();
    if (snap.exists) {
      const data = { uid: snap.id, ...snap.data() } as WalletType;
      return data;
    } else {
      return null;
    }
  }

  // Crear un nuevo elemento
  async create(item: WalletType): Promise<DocumentReference<WalletType>> {
    return await this.collection.add(item);
  }

  // Actualizar un elemento
  async update(uid: string, item: WalletType): Promise<void> {
    await this.collection.doc(uid).update(item);
  }

  // Eliminar un elemento
  async delete(uid: string): Promise<void> {
    await this.collection.doc(uid).delete();
  }
}
